"use client"

import * as AccordionPrimitive from "@radix-ui/react-accordion"
import { ChevronDownIcon } from "lucide-react"
import * as React from "react"

import { cn } from "@/lib/utils"

function Accordion({
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Root>) {
  return <AccordionPrimitive.Root data-slot="accordion" {...props} />
}

function AccordionItem({
  className,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Item>) {
  return (
    <AccordionPrimitive.Item
      data-slot="accordion-item"
      className={cn("border-none shadow-sm", className)}
      {...props}
    />
  )
}

function AccordionTrigger({
  className,
  children,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Trigger>) {
  return (
    <AccordionPrimitive.Header className="flex border-b border-gray-200">
      <AccordionPrimitive.Trigger
        data-slot="accordion-trigger"
        className={cn(
          "focus-visible:border-ring  focus-visible:ring-ring/50 flex flex-1 items-center justify-between gap-4 rounded-lg py-4 border-none text-left text-sm font-medium transition-all outline-none focus-visible:ring-[3px] cursor-pointer disabled:opacity-50 [&[data-state=open]>span>svg]:rotate-180",
          className
        )}
        {...props}
      >
        {children}
        <span className="cursor-pointer flex items-center justidy-center translate-y-0.5 transition-transform duration-200 rounded-full bg-secondary/10 p-1">
          <ChevronDownIcon className="text-secondary pointer-events-none size-4 shrink-0 transition-transform duration-200" />
        </span>
      
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
  )
}

function AccordionContent({
  className,
  children,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Content>) {
  return (
    <AccordionPrimitive.Content
      data-slot="accordion-content"
      className="data-[state=closed]:animate-accordion-up  data-[state=open]:animate-accordion-down overflow-hidden text-sm border-none shadow-none"
      {...props}
    >
      <div className={cn("pt-0 pb-4", className)}>{children}</div>
    </AccordionPrimitive.Content>
  )
}

export { Accordion, AccordionContent,AccordionItem, AccordionTrigger }
